// src/components/icons/loader.js
import React from 'react';

const IconLoader = () => null;

export default IconLoader;
